import styled from "styled-components"
import { BaseInput } from "../base-input/BaseInput"

export const TextareaInput = styled(BaseInput).attrs({
  as: "textarea",
  rows: 5,
})`
  height: auto;
`
